import { Controller } from "@hotwired/stimulus"
import { icon as brandIcon } from "../lib/icons"

export default class extends Controller {
  static targets = [
    "nameInput", "descriptionInput", "activeToggle", "submitButton"
  ]

  static values = {
    templateId: Number,
    condoId: Number
  }

  connect() {
    this.validateForm()
  }

  validateName(event) {
    const input = event.target
    const value = input.value.trim()

    if (value.length === 0) {
      input.classList.add('input-error')
      this.showFieldError(input, 'El nombre es requerido')
    } else if (value.length < 3) {
      input.classList.add('input-error')
      this.showFieldError(input, 'El nombre debe tener al menos 3 caracteres')
    } else {
      input.classList.remove('input-error')
      this.hideFieldError(input)
    }

    this.validateForm()
  }

  validateDescription(event) {
    const input = event.target
    const value = input.value.trim()

    if (value.length === 0) {
      input.classList.add('textarea-error')
      this.showFieldError(input, 'La descripción es requerida')
    } else if (value.length < 10) {
      input.classList.add('textarea-error')
      this.showFieldError(input, 'La descripción debe tener al menos 10 caracteres')
    } else {
      input.classList.remove('textarea-error')
      this.hideFieldError(input)
    }

    this.validateForm()
  }

  validateForm() {
    const name = this.nameInputTarget.value.trim()
    const description = this.descriptionInputTarget.value.trim()

    const isValid = name.length >= 3 && description.length >= 10

    this.submitButtonTarget.disabled = !isValid

    return isValid
  }

  previewCalculation() {
    if (!this.templateIdValue) {
      this.showAlert('warning', 'Guarda la plantilla primero para generar vista previa')
      return
    }

    const url = `/billing_templates/${this.templateIdValue}/preview`

    // Open preview in a new window/modal
    window.open(url, 'template_preview', 'width=800,height=600,scrollbars=yes')
  }

  showFieldError(input, message) {
    // Remove existing error message
    this.hideFieldError(input)

    // Create error message
    const errorDiv = document.createElement('div')
    errorDiv.className = 'label'
    errorDiv.innerHTML = `<span class="text-xs text-error">${message}</span>`
    errorDiv.setAttribute('data-error-for', input.name)

    // Insert after the input's parent fieldset
    const formControl = input.closest('.fieldset')
    if (formControl) {
      formControl.appendChild(errorDiv)
    }
  }

  hideFieldError(input) {
    const formControl = input.closest('.fieldset')
    if (formControl) {
      const existingError = formControl.querySelector(`[data-error-for="${input.name}"]`)
      if (existingError) {
        existingError.remove()
      }
    }
  }

  showAlert(type, message) {
    const alertClass = type === 'error' ? 'alert-error' : type === 'warning' ? 'alert-warning' : 'alert-info'

    const alertDiv = document.createElement('div')
    alertDiv.className = `alert ${alertClass} mb-4`
    alertDiv.innerHTML = `
      ${brandIcon("exclamation-triangle", "w-6 h-6")}
      <span>${message}</span>
    `

    this.element.insertBefore(alertDiv, this.element.firstChild)

    setTimeout(() => {
      if (alertDiv.parentNode) {
        alertDiv.remove()
      }
    }, 5000)
  }

  // Handle form submission
  handleSubmit(event) {
    if (!this.validateForm()) {
      event.preventDefault()
      this.showAlert('error', 'Por favor, completa todos los campos requeridos correctamente')

      // Focus on first invalid field
      const firstError = this.element.querySelector('.input-error, .textarea-error')
      if (firstError) {
        firstError.focus()
      }
    }
  }
}
